import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';

function Tooltip(props: TooltipProps) {
  return <MuiTooltip {...props} />;
}

export default Tooltip;
